module.exports = __webpack_public_path__ + "static/media/language7.6bb410a7.png";